import React from 'react'
import { Card, Carousel, CarouselItem, Col, Row } from 'react-bootstrap'
import CardContent from './common/CardContent'

const CharacterDrawingProcess = () => {
  return (
    <>
      <Card className='no-border rounded-0 container text-center'>
        <Row>
            <Col sm={{span:12, offset:0}} className="character-drawing-first-cloumn">
                <CardContent
                    subtitle="Creative Character  Drawing Process"
                    text="In addition to the precision skills of our artists expert in photorealistic modeling, the intangible, innate talent of our creative artists is evident when a pencil sketch can transform into original characters with their own unique style and personality. Here are a few examples of AR “mascot” cha racters created from scratch. Whatever you can image, we can create."
                    cardClass="no-border rounded-0"
                    subtitleClass="character-drawing-process-subtitle py-2"
                    textClass="architectural-mdeling-text text-500 text-muted py-2"
                    borderbottom=""
                />
            </Col>
        </Row>
      </Card>
      
      <Card className='no-border rounded-0 winery-carousel-section py-4 py-md-5 my-5 my-md-0 container'>
            <Row>
                <Col>
                <Carousel className='character-drawing-carousel container'  variant="dark" indicators={false} interval={6000} >
                <CarouselItem>
                        <Row>
                            
                            <Col xs={{span:10, offset:1}} md={{span:5, offset:1}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item'>
                                        <Col xs={{span:6, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch001.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} className="first-character-result-1">
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch002.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xs={{span:5, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card d-none d-md-block">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item last-character-slider-1'>
                                        <Col xs={{span:6, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch003.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} className="first-character-result-1" >
                                            <img className='character-drawing-process-slider-image-1 img-fluid' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch004.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem>
                        <Row>
                            
                            <Col xs={{span:10, offset:1}} md={{span:5, offset:1}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item'>
                                        <Col xs={{span:6, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch003.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} className="first-character-result-1">
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch004.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                            <Col xs={{span:5, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card d-none d-md-block">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item last-character-slider-1'>
                                        <Col xs={{span:6, offset:0}} md={{span:4, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch005.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} md={{span:8, offset:0}} className="first-character-result-1" >
                                            <img className='character-drawing-process-slider-image-1 img-fluid  last-character-image' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch006.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>

                    <CarouselItem >
                        <Row>
                            
                            <Col xs={{span:10, offset:1}} md={{span:5, offset:1}} className="industrial-invironments-slider-card">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item last-character-slider-1'>
                                        <Col xs={{span:6, offset:0}} md={{span:4, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch005.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} md={{span:8, offset:0}} className="first-character-result-1" >
                                            <img className='character-drawing-process-slider-image-1 img-fluid  last-character-image' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch006.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                                
                            </Col>
                            <Col xs={{span:5, offset:0}} md={{span:5, offset:0}} className="industrial-invironments-slider-card d-none d-md-block">
                                <Card className='no-border rounded-0 character-drawing-card'>
                                    <Row className='character-carousel-item'>
                                        <Col xs={{span:6, offset:0}}>
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch001.jpg"} alt="" />
                                        </Col>
                                        <Col xs={{span:6, offset:0}} className="first-character-result-1">
                                            <img className='character-drawing-process-slider-image-1 img-fluid ' src={process.env.PUBLIC_URL + "assets/character/creative-process/ch002.jpg"} alt="" />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Sketch</Card.Title> </Col>
                                        <Col><Card.Title className='pt-3 pb-0 character-carousel-item-footer'>Result</Card.Title></Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </CarouselItem>
                </Carousel>
                </Col>
            </Row>
            </Card>
    </>
  )
}

export default CharacterDrawingProcess
